// Re-export from jwtTokenManager for backward compatibility
// This module previously had its own implementation with a different localStorage key (api_token_data)
// Now consolidated to use the same redux-state key as jwtTokenManager
import { initializeJwtToken, getJwtToken } from './jwtTokenManager.js';

/**
 * Get API token, fetching from server if not in localStorage
 * @returns {Promise<string|null>} The JWT token or null
 */
export async function getApiToken() {
  // First check if token already exists
  const existingToken = getJwtToken();
  if (existingToken?.auth?.token) {
    return existingToken.auth.token;
  }

  // Initialize (fetch) token if not present
  const tokenData = await initializeJwtToken();
  if (!tokenData?.auth?.token) {
    console.warn('[getApiToken] Failed to obtain API token. Ensure <meta name="user-id"> is present and /app/create-api-token-by-session is accessible.');
  }
  return tokenData?.auth?.token || null;
}

// Expose getApiToken globally for legacy code that needs async token access
window.getApiToken = getApiToken;
